import React, { MouseEvent } from "react"

import { useAccount, useLayerPopupContext } from "@shared/contexts"
import { open as popupOpen } from "@shared/modules"

interface Props {
  to: string
  title: string
  target?: string | undefined
  scheduleId?: number | undefined
  className?: string
  children?: React.ReactNode
}

export default function CustomLink({
  to,
  title,
  target,
  scheduleId,
  className,
  children,
}: Props) {
  const { open } = useLayerPopupContext()
  const { account } = useAccount()

  const isAnonymous = account?.viewer?.role === "ANONYMOUS"

  return (
    <a
      href="#!"
      title={title}
      className={className}
      onClick={(e: MouseEvent) => {
        e.preventDefault()
        if (isAnonymous) {
          return open("ANONYMOUS")
        }

        const { availWidth, availHeight } = (window as any).screen
        const option =
          "fullscreen=yes,location=no,menubar=no,status=no,toolbar=no,directories"

        return popupOpen(
          to,
          title,
          `width=${availWidth},height=${availHeight},${option}`,
        )
      }}
    >
      {children ?? title}
    </a>
  )
}
